import { useState } from "react";
import { useNavigate } from "react-router-dom";

import Hero from "../components/Hero";

import About4C from "../components/About4C";
import ho1 from "../assets/ho1.png";
import ho2 from "../assets/ho2.png";
import ho3 from "../assets/ho3.png";
import ho4 from "../assets/ho4.png";

import "../styles/why.css";
import "../styles/envision.css";
import "../styles/testimonials.css";
import "../styles/why4c.css";
import "../styles/about4c.css";
import "../styles/programcards.css";

import scrollReveal from "../utils/useRevealOnScroll";

export default function Home() {
  scrollReveal();
  const navigate = useNavigate();  

  const [activeIndex, setActiveIndex] = useState(null);
  const [index, setIndex] = useState(0);

  const cards = [
    {
      title: "Creativity",
      text: "Every child receives individual care that helps them focus and sustain attention.",
      icon: "https://cdn-icons-png.freepik.com/512/11541/11541876.png",
    },
    {
      title: "Critical Thinking",
      text: "Exceptional care stems from the dedication and expertise of our staff.",
      icon: "https://encrypted-tbn2.gstatic.com/images?q=tbn:ANd9GcQWqox769GXC809CNj4I7z_RG1_NfckWA-iQDC4rnNLFNGn7xLA",
    },
    {
      title: "Communication",
      text: "We prioritize every aspect of development so learners can explore freely.",
      icon: "https://images.squarespace-cdn.com/content/v1/673cb55255bd0a433eb2c455/7de10215-d52e-421b-9b32-979e93f910a4/Services+Icons_lightblue_Group.png",
    },
    {
      title: "Collaboration",
      text: "Learning becomes joyful, engaging, and meaningful through fun-filled teaching.",
      icon: "https://i0.wp.com/atgtogether.com/wp-content/uploads/2024/05/social-media-posts-500-x-500-px-33.png?resize=800,800&ssl=1",
    },
  ];
  
  const toggleActive = (i) => {
    setActiveIndex((prev) => (prev === i ? null : i));
  };


  const slides = [
    {
      leftTitle: "Automation and AI are Reshaping the Job Market",
      leftText: "",
      img: ho1,
      rightText:
        "Repetitive tasks are becoming automated, requiring a workforce with adaptability, problemsolving skills, and innovation. The 4Cs are the key to unlocking human potential in this new landscape.",
    },
    {
      leftTitle: "Global Challenges Demand Collaborative Solutions",
      leftText: "",
      img: ho2,
      rightText:
        "From climate change to pandemics, addressing complex issues requires teams with strong communication, collaboration, and critical thinking skills.",
    },
    {
      leftTitle: "Beyond Technical Skills",
      leftText: "",
      img: ho3,
      rightText:
        "While STEM skills are vital, they're incomplete without the 'soft skills' like communication and collaboration. essential for success in any field.",
    },
    {
      leftTitle: "The Skills Gap is Widening",
      leftText: "",
      img: ho4,
      rightText:
        "Traditional education often focuses on rote memorization, leaving students unprepared for the demands of the modern world. The 4Cs bridge this gap by fostering critical thinking, creativity, and effective communication.",
    },
  ];

  const nextSlide = () => setIndex((prev) => (prev + 1) % slides.length);
  const prevSlide = () => setIndex((prev) => (prev - 1 + slides.length) % slides.length);

  const about4c = {
    title: "This future is not a distant dream",
    desc1: "It’s a reality made possible through the cultivation of the 4Cs:",
    main: "Creativity, Critical Thinking, Communication, and Collaboration.",
    desc2:
      "Investing in the 4Cs is an investment in a generation poised to thrive in the rapidly evolving world.",
    img: "https://sproutks.com/wp-content/uploads/2024/10/Frame-2-1096x1536.jpg",
  };
  return (
    
    <>
    
      <Hero />
      
    
<section className="program-section reveal">
  <div className="program-wrapper">

    {[
      {
        title: "For School Students",
        icon: "https://cdn-icons-png.flaticon.com/128/1048/1048947.png",
        path: "/syllabus/schools",
      },
      {
        title: "For College Students",
        icon: "https://cdn-icons-png.flaticon.com/128/5351/5351067.png",
        path: "/syllabus/colleges",
      },
      {
        title: "For Corporate Employees",
        icon: "https://cdn-icons-png.flaticon.com/128/10857/10857085.png",
        path: "/syllabus/corporates",
      },
      {
        title: "For Banking Aspirants",
        icon: "https://cdn-icons-png.flaticon.com/128/3135/3135715.png",
        path: "/syllabus/banking",
      },
      {
        title: "Faculty Development Program",
        icon: "https://cdn-icons-png.flaticon.com/128/9746/9746423.png",
        path: "/syllabus/fdp",
      },
      {
        title: "Home Makers",
        icon: "https://cdn-icons-png.flaticon.com/128/18104/18104998.png",
        path: "/syllabus/homemakers",
      },
].map((item, i) => (

      <div
  key={i}
  className="program-card reveal"
  style={{ transitionDelay: `${i * 150}ms` }}
  onClick={() => navigate(item.path)}
>
        <div className="light-sweep"></div>

        <img
          src={item.icon}
          className="program-icon"
          alt={item.title}
        />

        <h3 className="program-title">{item.title}</h3>
      </div>
    ))}

  </div>
</section>

      <div className="program-intro">
  <p className="reveal">
      Welcome to Sprout! Our goal as a forward-thinking Indo-European business is to equip
      professionals and students with the critical skills of the twenty-first century.
      Our objective is to offer a comprehensive approach to education that enables
      professionals and students to prosper in a globalized world by merging Europe’s
      inventive methods with India’s rich cultural legacy and superior educational standards.
  </p>

  <p className="reveal reveal-delay">
      At Sprout, we think the 4Cs have the ability to change lives. To teach the 4Cs,
      we employ a variety of technological tools, project-based learning strategies,
      and activities and games that require problem-solving. Our goal is to promote growth
      in a welcoming, inclusive environment and to make excellent learning accessible.
  </p>
</div>


      {/* WHY CHOOSE US */}
      <section className="why-choose-section reveal">
        {cards.map((c, i) => (
          <div
            key={i}
            className={`why-card reveal ${activeIndex === i ? "active" : ""}`}
            onClick={() => toggleActive(i)}
            style={{ transitionDelay: `${i * 120}ms` }}
          >
            <div className="icon-wrapper">
              <img src={c.icon} alt={c.title} />
            </div>

            <span className="big-number">{i + 1}</span>
            <h3 className="why-title">{c.title}</h3>
            <p className="why-text">{c.text}</p>
          </div>
        ))}
      </section>

      {/* MISSION */}
      <section className="mission-section reveal">
        <h2 className="mission-title">Envision a Future Where</h2>

        <div className="mission-box-wrapper">
          {[0,1,2].map((i) => (
            <div 
              key={i} 
              className={`mission-box reveal`} 
              style={{ transitionDelay: `${i * 150}ms` }}
            >
              <img
                src={
                  i === 0
                    ? "https://cdn-icons-png.flaticon.com/512/702/702797.png"
                    : i === 1
                    ? "https://cdn-icons-png.flaticon.com/128/5609/5609003.png"
                    : "https://cdn-icons-png.flaticon.com/128/13322/13322243.png"
                }
                className="mission-icon"
                alt="mission"
              />
              <p>
                {i === 0
                  ? "Students are empowered to solve real-world challenges rather than merely memorizing facts"
                  : i === 1
                  ? "Education fosters critical thinking to equip learners for the complex decisions they'll face"
                  : " Collaboration is a cornerstone of learning , driving , innovation and progress"}
              </p>
            </div>
          ))}
        </div>
      </section>

   <About4C data={about4c} />
   

      {/* LAYER 3 */}
      <section className="future-layer3 reveal">
        <h2 className="layer3-title">The 4Cs: Essential Skills for the 21st Century</h2>
        <p className="layer3-text">
          Imagine a generation capable of <b>creating, analyzing, collaborating</b>.
        </p>
        <p className="layer3-text">
          Beyond buzzwords, the 4Cs are the <b>indispensable skills</b> required for success.
        </p>
      </section>
      

      {/* WHY 4C SLIDER */}
      <section className="why4c-wrapper reveal">
        <h2 className="why4c-main-title">Why the 4Cs Are in High Demand</h2>

        <div className="why4c-container reveal">
          <div className="why4c-text reveal">
            <h3 className="reveal">{slides[index].leftTitle}</h3>
            <p className="reveal">{slides[index].leftText}</p>
          </div>

          <div className="why4c-image reveal">
            <img src={slides[index].img} alt="visual" />
          </div>

          <div className="why4c-text reveal">
            <p className="reveal">{slides[index].rightText}</p>
          </div>
        </div>

        <div className="why4c-pagination reveal">
          <button className="why4c-arrow" onClick={prevSlide}>←</button>
          <span className="why4c-counter">{index + 1} / {slides.length}</span>
          <button className="why4c-arrow" onClick={nextSlide}>→</button>
        </div>
      </section>

    {/* TESTIMONIALS */}
<section className="testimonials-section reveal">

  <h2 className="testimonials-title reveal">
    Join others transforming their lives through learning
  </h2>

  <div className="testimonials-slider reveal">
    <div className="testimonials-track">

      {/* Testimonial 1 */}
      <div className="testimonial-card reveal" style={{ transitionDelay: "0ms" }}>
        <p className="quote">“</p>
        <p className="text">
          The teaching was very effective and engaging. The concepts were explained clearly with relevant examples making it easier to understand even complex topics. The teacher encouraged participation and patiently clarified doubts, which created a supportive learning environment. The use of practical insights along with theoretical explanations kept the sessions interesting and meaningful. Overall, the teaching style was interactive, student-focused, and greatly enhanced my learning experience.
My exact review about his teaching.
        </p>
        <div className="profile no-image">
          <div className="profile-info">
            <p className="name">Karthikeyan M</p>
            
          </div>
        </div>
      </div>

      {/* Testimonial 2 */}
      <div className="testimonial-card reveal" style={{ transitionDelay: "120ms" }}>
        <p className="quote">“</p>
        <p className="text">
          The JDBC workshop was easy to understand and interactive. The trainer explained concepts step by step and cleared our doubts patiently. It helped us gain confidence in working with databases using Java. Thank you for organizing such a useful session.
        </p>
        <div className="profile no-image">
          <div className="profile-info">
            <p className="name">Janani K</p>
          
          </div>
        </div>
      </div>

      {/* Testimonial 3 */}
      <div className="testimonial-card reveal" style={{ transitionDelay: "240ms" }}>
        <p className="quote">“</p>
        <p className="text">
          The MERN workshop was well-organized and informative, covering both frontend and backend concepts clearly.
Hands-on sessions helped reinforce learning through practical implementation.
The instructor explained complex topics in a simple, engaging manner.
A great learning experience—looking forward to more advanced sessions!
        </p>
        <div className="profile no-image">
          <div className="profile-info">
            <p className="name">Gobiga V</p>
            
          </div>
        </div>
      </div>

      {/* Testimonial 4 */}
      <div className="testimonial-card reveal" style={{ transitionDelay: "360ms" }}>
        <p className="quote">“</p>
        <p className="text">
         The MERN add-on course was very useful and practical. I gained a clear understanding of how MongoDB, Express, React, and Node.js work together to build full-stack applications. The course covered both theory and hands-on projects, which helped me apply the concepts in real time.
        </p>
        <div className="profile no-image">
          <div className="profile-info">
            <p className="name">Sandhiya R</p>
            
          </div>
        </div>
      </div>

      {/* Testimonial 5 */}
      <div className="testimonial-card reveal" style={{ transitionDelay: "480ms" }}>
        <p className="quote">“</p>
        <p className="text">
       Actually, the session was really amazing and we learned a lot about our career and placement 
And also we learned about prompt engineering and other technical domains 
In this session they also provide about project topics involved in various domains and their things ,So overall this session is very usefull for our career 
Thankyou!
        </p>
        <div className="profile no-image">
          <div className="profile-info">
            <p className="name">Shahidh</p>
            
          </div>
        </div>
      </div>

    </div>
  </div>
</section>



    </>
  );
}
